let modal1 = document.getElementById("popup-1");
let modal1ty = document.getElementById("popup-1-ty");
let btn1 = document.getElementsByClassName("open-popup-1");
let span1 = document.getElementsByClassName("close-1")[0];
let span1ty = document.getElementsByClassName("close-1-ty")[0];

let modal2 = document.getElementById("popup-2");
let modal2ty = document.getElementById("popup-2-ty");
let btn2 = document.getElementsByClassName("open-popup-2");
let span2 = document.getElementsByClassName("close-2")[0];
let span2ty = document.getElementsByClassName("close-2-ty")[0];

for (let i = 0; i < btn1.length; i++) {
  btn1[i].onclick = function () {
    modal1.classList.toggle("active");
    document.body.classList.add("is-popup");
  };
}
for (let i = 0; i < btn2.length; i++) {
  btn2[i].onclick = function () {
    modal2.classList.toggle("active");
    document.body.classList.add("is-popup");
  };
}

// span1.onclick = function () {
//   modal1.classList.toggle("active");
// };
span1ty.onclick = function () {
  modal1ty.classList.toggle("active");
  document.body.classList.remove("is-popup");
};
span2.onclick = function () {
  modal2.classList.toggle("active");
  document.body.classList.remove("is-popup");
};
span2ty.onclick = function () {
  modal2ty.classList.toggle("active");
  document.body.classList.remove("is-popup");
};
window.onclick = function (event) {
  if (event.target == modal1) {
    modal1.classList.toggle("active");
    document.body.classList.remove("is-popup");
  }
  if (event.target == modal1ty) {
    modal1ty.classList.toggle("active");
    document.body.classList.remove("is-popup");
  }
  if (event.target == modal2) {
    modal2.classList.toggle("active");
    document.body.classList.remove("is-popup");
  }
  if (event.target == modal2ty) {
    modal2ty.classList.toggle("active");
    document.body.classList.remove("is-popup");
  }
};

// popup forms
document.addEventListener(
  "wpcf7mailsent",
  function (event) {
    if ("5" == event.detail.contactFormId) {
      // modal1.classList.toggle("active");
      modal1ty.classList.toggle("active");
    }
  },
  false
);
document.addEventListener(
  "wpcf7mailsent",
  function (event) {
    if ("372" == event.detail.contactFormId) {
      modal2.classList.toggle("active");
      modal2ty.classList.toggle("active");
    }
  },
  false
);
// page forms
document.addEventListener(
  "wpcf7mailsent",
  function (event) {
    if ("371" == event.detail.contactFormId) {
      modal1ty.classList.toggle("active");
    }
  },
  false
);
document.addEventListener(
  "wpcf7mailsent",
  function (event) {
    if ("919" == event.detail.contactFormId) {
      modal1ty.classList.toggle("active");
    }
  },
  false
);
document.addEventListener(
  "wpcf7mailsent",
  function (event) {
    if ("1422" == event.detail.contactFormId) {
      modal1ty.classList.toggle("active");
    }
  },
  false
);
//other multilangual forms
document.addEventListener(
  "wpcf7mailsent",
  function (event) {
    if ("1265" == event.detail.contactFormId) {
      modal1ty.classList.toggle("active");
    }
  },
  false
);
document.addEventListener(
  "wpcf7mailsent",
  function (event) {
    if ("1183" == event.detail.contactFormId) {
      modal1ty.classList.toggle("active");
    }
  },
  false
);
document.addEventListener(
  "wpcf7mailsent",
  function (event) {
    if ("1297" == event.detail.contactFormId) {
      modal1ty.classList.toggle("active");
    }
  },
  false
);
document.addEventListener(
  "wpcf7mailsent",
  function (event) {
    if ("1293" == event.detail.contactFormId) {
      modal1ty.classList.toggle("active");
    }
  },
  false
);
document.addEventListener(
  "wpcf7mailsent",
  function (event) {
    if ("1266" == event.detail.contactFormId) {
      modal1ty.classList.toggle("active");
    }
  },
  false
);
document.addEventListener(
  "wpcf7mailsent",
  function (event) {
    if ("1182" == event.detail.contactFormId) {
      modal1ty.classList.toggle("active");
    }
  },
  false
);
document.addEventListener(
  "wpcf7mailsent",
  function (event) {
    if ("1298" == event.detail.contactFormId) {
      modal1ty.classList.toggle("active");
    }
  },
  false
);
document.addEventListener(
  "wpcf7mailsent",
  function (event) {
    if ("1294" == event.detail.contactFormId) {
      modal1ty.classList.toggle("active");
    }
  },
  false
);
document.addEventListener(
  "wpcf7mailsent",
  function (event) {
    if ("1267" == event.detail.contactFormId) {
      modal1ty.classList.toggle("active");
      modal2.classList.remove("active");
    }
  },
  false
);
document.addEventListener(
  "wpcf7mailsent",
  function (event) {
    if ("1181" == event.detail.contactFormId) {
      modal1ty.classList.toggle("active");
      modal2.classList.remove("active");
    }
  },
  false
);
document.addEventListener(
  "wpcf7mailsent",
  function (event) {
    if ("1299" == event.detail.contactFormId) {
      modal1ty.classList.toggle("active");
      modal2.classList.remove("active");
    }
  },
  false
);
document.addEventListener(
  "wpcf7mailsent",
  function (event) {
    if ("1295" == event.detail.contactFormId) {
      modal1ty.classList.toggle("active");
      modal2.classList.remove("active");
    }
  },
  false
);
document.addEventListener(
  "wpcf7mailsent",
  function (event) {
    if ("1268" == event.detail.contactFormId) {
      modal1ty.classList.toggle("active");
    }
  },
  false
);
document.addEventListener(
  "wpcf7mailsent",
  function (event) {
    if ("1180" == event.detail.contactFormId) {
      modal1ty.classList.toggle("active");
    }
  },
  false
);
document.addEventListener(
  "wpcf7mailsent",
  function (event) {
    if ("1300" == event.detail.contactFormId) {
      modal1ty.classList.toggle("active");
    }
  },
  false
);
document.addEventListener(
  "wpcf7mailsent",
  function (event) {
    if ("1296" == event.detail.contactFormId) {
      modal1ty.classList.toggle("active");
    }
  },
  false
);
// subscribe
document.addEventListener(
  "wpcf7mailsent",
  function (event) {
    if ("1532" == event.detail.contactFormId) {
      modal1ty.classList.toggle("active");
    }
  },
  false
);
document.addEventListener(
  "wpcf7mailsent",
  function (event) {
    if ("1533" == event.detail.contactFormId) {
      modal1ty.classList.toggle("active");
    }
  },
  false
);
document.addEventListener(
  "wpcf7mailsent",
  function (event) {
    if ("1535" == event.detail.contactFormId) {
      modal1ty.classList.toggle("active");
    }
  },
  false
);
document.addEventListener(
  "wpcf7mailsent",
  function (event) {
    if ("1534" == event.detail.contactFormId) {
      modal1ty.classList.toggle("active");
    }
  },
  false
);